import { Copy, Send, MapPin } from "lucide-react";
import { useState } from "react";
import templeOverlay from "../assets/temple-overlay.png";
import MobileNavbar from "../components/MobileNavbar";


const palette = {
  bg: "#FFF8F0",
  ink: "#241B18",
};

export default function Contact() {
  const [copied, setCopied] = useState(null);

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(text);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <div className="relative min-h-screen w-full">
      {/* MOBILE NAVBAR */}
      <MobileNavbar />
      {/* BACKGROUND OVERLAY (same pattern as Gallery) */}
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: palette.bg,
          backgroundImage: `url(${templeOverlay})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          opacity: 0.18,
          mixBlendMode: "overlay",
          zIndex: 0,
        }}
      />

      {/* CONTENT LAYER */}
      <div className="relative z-10 pt-16 md:pt-0">
      <section
        className="relative z-10 py-12 px-6 max-w-4xl mx-auto"
        style={{ color: palette.ink }}
      >
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <h2 className="text-3xl font-bold text-sapphire mb-6">
              Contact Us
            </h2>

            <div className="flex items-center gap-2 mb-2">
              <p>📍 2481 Taunton Rd #121, Oakville L6H 3R7</p>
              <button
                onClick={() =>
                  handleCopy("2481 Taunton Rd #121, Oakville L6H 3R7")
                }
                className="text-gray-500 hover:text-gray-700"
              >
                <Copy size={16} />
              </button>
              <a
                href="https://www.google.com/maps?sca_esv=b1a2f407046ddbac&rlz=1C1GCEA_enCA1133CA1133&sxsrf=AE3TifMnvca7YjrM9CICoH2znHKWHhVEFg:1763011748876&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiFWNhcm5hdGNpIGNhZmUgb2FrdmlsZTIIEAAYCBgNGB4yBRAAGO8FMggQABiABBiiBDIIEAAYogQYiQUyCBAAGIAEGKIEMgUQABjvBUjgF1CtA1jdFXABeAGQAQGYAYcCoAHPCKoBBTQuMi4yuAEDyAEA-AEBmAIIoALiBsICChAAGLADGNYEGEfCAg0QABiABBiwAxhDGIoFwgIOEAAYsAMY5AIY1gTYAQHCAhkQLhiABBiwAxhDGMcBGMgDGIoFGK8B2AEBwgIHEAAYgAQYDcICDRAuGIAEGMcBGA0YrwHCAgYQABgWGB6YAwDiAwUSATEgQIgGAZAGEroGBggBEAEYCZIHBTUuMi4xoAeQM7IHBTQuMi4xuAfcBsIHBTAuNi4yyAcR&um=1&ie=UTF-8&fb=1&gl=ca&sa=X&geocode=KR8Nvki0QyuIMY2FxiEuJOlH&daddr=2481+Taunton+Rd,+Oakville,+ON+L6H+3R7"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-gray-700"
              >
                <MapPin size={16} />
              </a>
              {copied === "2481 Taunton Rd #121, Oakville L6H 3R7" && (
                <span className="text-sm text-green-500">Copied!</span>
              )}
            </div>

            <div className="flex items-center gap-2 mb-2">
              <p>📞 +1 (365) 726-1646</p>
              <button
                onClick={() => handleCopy("+1 (289) 123-4567")}
                className="text-gray-500 hover:text-gray-700"
              >
                <Copy size={16} />
              </button>
              {copied === "+1 (365) 726-1646" && (
                <span className="text-sm text-green-500">Copied!</span>
              )}
            </div>

            <div className="flex items-center gap-2">
              <p>📧 contactus@carnaticcafe.ca</p>
              <button
                onClick={() => handleCopy("contactus@carnaticcafe.ca")}
                className="text-gray-500 hover:text-gray-700"
              >
                <Copy size={16} />
              </button>
              {copied === "contactus@carnaticcafe.ca" && (
                <span className="text-sm text-green-500">Copied!</span>
              )}
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-bold text-sapphire mb-6">
              Send Us a Message
            </h2>
            <form className="bg-blush/20 p-6 rounded-xl shadow space-y-4">
              <input
                type="text"
                placeholder="Name"
                className="w-full p-3 rounded border"
              />
              <input
                type="email"
                placeholder="Email*"
                className="w-full p-3 rounded border"
              />
              <input
                type="tel"
                placeholder="Phone"
                className="w-full p-3 rounded border"
              />
              <textarea
                placeholder="Tell us your enquiry"
                className="w-full p-3 rounded border"
                rows="4"
              ></textarea>
              <button className="w-full bg-orange text-white py-3 rounded-xl font-semibold hover:bg-sapphire flex items-center justify-center gap-2">
                Send Message <Send size={16} />
              </button>
            </form>
          </div>
        </div>
      </section>
      </div>
    </div>
  );
}
